import {Injectable} from '@angular/core';
import {BaseurlService} from './baseurl.service';
import { HttpClient } from '@angular/common/http';
import {EnergyModel} from '../model/EnergyModel';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnergyService {

  constructor(
    private baseurlService: BaseurlService,
    private http: HttpClient
  ) { }

  getAllEnergyEntries(): Observable<EnergyModel[]> {
    return this.http.get<EnergyModel[]>(`${this.baseurlService.getBaseUrl()}/energy`);
  }

  save(save: EnergyModel): Observable<void> {
    if (!save.id) {
      return this.http.post<void>(`${this.baseurlService.getBaseUrl()}/energy`, save);
    } else {
      return this.http.put<void>(`${this.baseurlService.getBaseUrl()}/energy/${save.id}`, save);
    }
  }
}
